import React from 'react';

import FavoriteViewModal from 'components/consumer/FavoriteViewModal';
import TradeUserSidebar from 'components/consumer/TradeUserSidebar/TradeUserSidebar';
import LoginSidebar from 'components/consumer/LoginSidebar/LoginSidebar';
import NotificationBanner from 'components/consumer/NotificationBanner';
import ChatUnavailableModal from 'components/consumer/ChatUnavailableModal';
import QuickViewModal from 'components/consumer/QuickViewModal';
import HookRunner from 'components/consumer/HookRunner';
import useToggleIsLoginSidebarOpen from 'global-state/isLoginSidebarOpen/useToggleIsLoginSidebarOpen';
import useIsLoginSidebarOpen from 'global-state/isLoginSidebarOpen/useIsLoginSidebarOpen';
import useFavoriteModalState from 'global-state/favoriteModalState/useFavoriteModalState';
import useResetFavoriteModalState from 'global-state/favoriteModalState/useResetFavoriteModalState';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useRefreshUserLocation from 'hooks/useRefreshUserLocation';
import useChatUnavailableModalState from './useChatUnavailableModalState';
import useQuickViewModalState from './useQuickViewModalState';

// The CommonModals component is used to render modals that need to be globally
// available on all pages.

// Since it is rendered on all pages (and only rendered once), it is also very
// useful to include any global hooks that need to be run on all pages. Ideally
// in future we should extract this to a separate component, named GlobalHooks.

const CommonModals = () => {
  // This chat modal hook also makes the chat open & close functions globally
  // available on the window object so that chat can be opened and close the
  // root App component in Consumer
  const {
    isOpen: isChatUnavailableOpen,
    close: closeChatUnavailableModal,
  } = useChatUnavailableModalState();

  const {
    isOpen: isQuickViewModalOpen,
    onClose: onCloseQuickViewModal,
    path: quickViewModalPath,
    slug: quickViewModalSlug,
    productVariation: quickViewProductVariation,
  } = useQuickViewModalState();

  const isLoginSidebarOpen = useIsLoginSidebarOpen();
  const toggleIsLoginSidebarOpen = useToggleIsLoginSidebarOpen();

  const favoriteModalState = useFavoriteModalState();
  const resetFavoriteModalState = useResetFavoriteModalState();

  // Render any additional hooks that need to be run on all pages
  useRefreshUserLocation();

  const showQuickViewModal = !!isQuickViewModalOpen && !!quickViewModalSlug;

  return (
    <>
      {showQuickViewModal && (
        <QuickViewModal
          isOpen
          onClose={onCloseQuickViewModal}
          path={quickViewModalPath}
          slug={quickViewModalSlug}
          variantSku={quickViewProductVariation}
        />
      )}

      {/* The HookRunner component is used to allow data to be loaded outside of React, which is necessary to support loading of product data within the QuickViewModal component */}
      <HookRunner />

      <TradeUserSidebar />

      <FavoriteViewModal
        isSideBarVisible={favoriteModalState.isOpen}
        productId={favoriteModalState.productId}
        onClose={resetFavoriteModalState}
      />

      <LoginSidebar
        show={isLoginSidebarOpen}
        onClose={toggleIsLoginSidebarOpen}
      />

      <NotificationBanner />

      <ChatUnavailableModal
        isOpen={isChatUnavailableOpen}
        onClose={closeChatUnavailableModal}
      />
    </>
  );
};

export default withBrowserOnly(CommonModals);
